import React, { useState, useEffect } from 'react';
import { getCaptchaId, getCaptchaImage } from '../../../../shared/service';
const CaptchaImage = () => {
  const [captchaId, setCaptchaId] = useState('');
  const [imageUrl, setImageUrl] = useState('');
  useEffect(() => {
    const fetchCaptcha = async () => {
      try {
        const data = await getCaptchaId();
        const { captcha_id } = data;
        setCaptchaId(captcha_id);
        localStorage.setItem('captcha', captcha_id)
      } catch (error) {
        console.error('Error fetching captcha ID:', error);
      }
    };

    fetchCaptcha();
  }, []);

  useEffect(() => {
    const fetchImage = async () => {
      try {
        if (captchaId) {
          const imageBlob = await getCaptchaImage(captchaId);
          const url = URL.createObjectURL(imageBlob);

          setImageUrl(url);
        }
      } catch (error) {
        console.error('Error fetching image:', error);
      }
    };

    fetchImage();
  }, [captchaId]);

  return (
    <div style={{textAlign: 'center'}}>
      {imageUrl ? (
        <img className='captcha-image' src={imageUrl} alt="Loaded from API" />
      ) : (
        <div className="loader"></div>
      )}
    </div>
  );
};

export default CaptchaImage;
